import React, { useEffect, useState } from 'react'
import {
  Grid,
  makeStyles,
  Paper,
  TextField,
  Checkbox,
  Button,
  Box
} from "@material-ui/core";
import { Autocomplete, createFilterOptions  } from "@material-ui/lab"
import { CheckBoxOutlineBlank, CheckBox as CheckboxIcon } from '@material-ui/icons';
import { useDispatch, useSelector } from "react-redux";
import { reportActions, businessUnitPropsAction } from "./../../actions"
import { KeyboardDatePicker } from '@material-ui/pickers';
import { formatDate } from '../../utils/date';
import { useHistory } from "react-router-dom";
import { BusinessUnitPropsCheckboxList } from "./../../components/Shared"
import { useTranslation } from 'react-i18next';

const filterOptions = createFilterOptions({
  limit: 100,
})

const useStyles = makeStyles((theme) => ({
  headerWrapper: {
    borderRadius: 8,
    border: `1px solid ${theme.palette.grey.main}`,
    backgroundColor: theme.palette.neutrals.high.main,
    padding: theme.spacing(3),
  },
  containerDate: {
    position: 'relative',
  },
  datePicker: {
    marginTop: 0,
    marginBottom: 0,
  },
  errorSpan: {
    position: 'absolute',
  },
  filterButton: {
    color: theme.palette.neutrals.high.main,
    backgroundColor: theme.palette.neutrals.low.main
  }
}))

export const ReportHeader = () => {
  const classes = useStyles();
  const history = useHistory();
  const { filters, paging, fieldValidation, loading, tab } = useSelector(state => state.report);
  const { local, occupationArea, businessUnit } = useSelector(state => state.businessUnitProps)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [splittedPathname] = useState(history.location.pathname.split("/"))

  function handleChangeStatus(data) {
    if (data) {
      dispatch(reportActions.changeStatus(data.option))
    } else {
      dispatch(reportActions.clearStatus())
    }
  }

  const handleStartDate = (date) => {
    if (date instanceof Date && isFinite(date)) {
      dispatch(reportActions.changeStartDate(date))
    }
  };

  const handleEndDate = (date) => {
    if (date instanceof Date && isFinite(date)) {
      dispatch(reportActions.changeEndDate(date))
    }
  };

  const handleClearFilters = () => {
    dispatch(reportActions.clearFilters())
    dispatch(businessUnitPropsAction.clearBusinessUnitPropField('occupationArea'))
    dispatch(businessUnitPropsAction.clearBusinessUnitPropField('local'))
    dispatch(businessUnitPropsAction.clearBusinessUnitPropField('businessUnit'))
  }

  function handleFilter() {
    let params = {
      statusCode: fieldValidation[splittedPathname[splittedPathname.length - 1]]?.status && filters.status.filter(item => item.checked).map(item => item.value),
      businessUnits: businessUnit.filter(item => item.checked && item.value !== "SELECT_ALL").map(item => item.value),
      locals: local.filter(item => item.checked && item.value !== "SELECT_ALL").map(item => item.value),
      occupationArea: occupationArea.filter(item => item.checked && item.value !== "SELECT_ALL").map(item => item.value),
      startDate: fieldValidation[splittedPathname[splittedPathname.length - 1]]?.startDate && formatDate(filters.startDate),
      endDate: fieldValidation[splittedPathname[splittedPathname.length - 1]]?.endDate && formatDate(filters.endDate),
      reportType: splittedPathname[splittedPathname.length - 1],
    }

    dispatch(reportActions.preFilter())

    if (tab === "table") {
      params = {
        ...params,
        page: 1,
        limit: paging.limit,
      }
      dispatch(reportActions.getReportData(params))

    } else {
      params = {
        ...params,
        page: -1,
      }
      dispatch(reportActions.getReportDataChart(params))
    }
  
  }

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Paper className={classes.headerWrapper} elevation={0}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={fieldValidation[splittedPathname[splittedPathname.length - 1]]?.status ? 8 : 12}>
              <BusinessUnitPropsCheckboxList businessUnitField = {fieldValidation[splittedPathname[splittedPathname.length - 1]]?.businessUnit} />
            </Grid>
            { fieldValidation[splittedPathname[splittedPathname.length - 1]]?.status && (
              <Grid item xs={12} md={4}>
                <Autocomplete 
                  multiple
                  disableCloseOnSelect
                  filterOptions={filterOptions}
                  id="checkboxes-status"
                  options={filters.status}
                  loading={filters.status.length === 0}
                  value={filters.status.filter(item => item.checked)}
                  onChange={ (e, items, options, details) => handleChangeStatus(details) }
                  getOptionLabel={(input) => input.label}
                  renderInput={(params) => (
                    <TextField {...params} label={t('status')} variant="filled" />
                  )}
                  renderTags={(option, state) => {
                    return (<span>{option.length > 1 ? `${option[0].label} +${option.length-1}` : option[0].label}</span>)
                  }}
                  renderOption={(value) => {
                    return (
                      <li>
                        <Checkbox
                          icon={<CheckBoxOutlineBlank fontSize="small" />}
                          checkedIcon={<CheckboxIcon fontSize="small" />}
                          style={{ marginRight: 8 }}
                          checked={value.checked}
                          />
                        {value.label}
                      </li>
                  )}}
                />
              </Grid>
            )}
            {fieldValidation[splittedPathname[splittedPathname.length - 1]]?.startDate &&
(<><Grid item xs={12} md={4} className={classes.containerDate}>
              <KeyboardDatePicker
                variant="dialog"
                inputVariant="filled"
                format="dd/MM/yyyy"
                disableFuture
                value={filters.startDate}
                fullWidth
                margin="normal"
                id="date-picker-inline"
                className={classes.datePicker}
                label={t('inicio')}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                invalidDateMessage={
                  filters.startDate && <span>Data de inicio inválida</span>
                }
                name="startDate"
                onChange={handleStartDate}
                autoOk
                maxDate={filters.endDate}
                maxDateMessage={
                  <span className={classes.errorSpan}>
                    A data não pode ser futura ou maior que a data de termino
                  </span>
                }
              />
            </Grid>
            <Grid item xs={12} md={4} className={classes.containerDate}>
              <KeyboardDatePicker
                variant="inline"
                inputVariant="filled"
                format="dd/MM/yyyy"
                value={filters.endDate}
                className={classes.datePicker}
                fullWidth
                disableFuture
                margin="normal"
                id="date-picker-inline-endDate"
                label={t('termino')}
                onChange={handleEndDate}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                invalidDateMessage={
                  <span className={classes.errorSpan}>
                    Data de termino invalida
                  </span>
                }
                name="endDate"
                minDate={filters.startDate}
                autoOk
                minDateMessage={
                  <span className={classes.errorSpan}>
                    A data de termino não pode ser inferior a data de inicio
                  </span>
                }
                maxDateMessage={
                  <span className={classes.errorSpan}>
                    A data de termino não pode ser uma data futura.
                  </span>
                }
              />
            </Grid></>)}
            <Grid item xs={6} md={2}>
              <Box display="flex" alignItems="center">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  onClick={handleFilter}
                >
                  {t('filtrar')}
                </Button>
              </Box>
            </Grid>
            <Grid item xs={6} md={2}>
              <Box display="flex" alignItems="center">
                <Button
                  onClick={handleClearFilters}
                  variant="text"
                  color="primary"
                >
                  {t('limpar_filtro')}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}
